import { Typography } from "@mui/material";
import { forwardRef } from "react";
const GrayBGText = forwardRef((props, ref) => {
  return (
    <Typography
      ref={ref}
      key={props.loc}
      sx={{
        color: "#303030",
        borderRadius: "14px",
        border: `1px solid gray`,
        padding: "2px 8px",
        minWidth: "32px",
        fontSize: "0.875rem",
        fontWeight: "400"
      }}
      textAlign={"center"}
    >
      {props.loc}
    </Typography>
  );
});

GrayBGText.displayName = "GrayBGText";

export default GrayBGText;
